var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WireframeNested',{attrs:{"title":"Dev"}},[_c('LayoutOneColumn',{staticClass:"pa-2"},[_c('p',[_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":_vm.resetUser}},[_vm._v("reset user")])],1),_c('p',[_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":_vm.resetPollMeme}},[_vm._v("reset poll meme")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }